import { z } from 'zod'

export const LEARNING_REQUIREMENTS_CONTRACT_VERSION = '1.0.0' as const
export const LEARNING_REQUIREMENTS_SCHEMA_VERSION = 'learning-requirements-v1' as const

const uuid = z.string().uuid()
const requiredText = z.string().trim().min(1).max(240)

export const learningRequirementEvaluationSchema = z.object({
  evaluationId: uuid,
  enrollmentId: uuid,
  frozenRequirementId: requiredText.max(180),
  status: z.enum(['satisfied', 'unsatisfied']),
  courseCompleted: z.boolean(),
  coursePassed: z.boolean(),
  evidenceAchievementId: uuid.nullable(),
  ruleVersion: requiredText.max(120),
  decidedAt: z.string().datetime({ offset: true }),
}).strict()

export const learningRequirementEvaluationsResponseSchema = z.object({
  contract_version: z.literal(LEARNING_REQUIREMENTS_CONTRACT_VERSION),
  items: z.array(learningRequirementEvaluationSchema),
}).strict()

export type LearningRequirementEvaluation = z.infer<typeof learningRequirementEvaluationSchema>
export type LearningRequirementEvaluationsResponse = z.infer<typeof learningRequirementEvaluationsResponseSchema>
